module.exports = __webpack_public_path__ + "img/smart-music-mission-flow.4c2812e5.png";